import type { ErrorEvent } from '@sentry/react';

import { DYNAMIC_IMPORT_FETCH_FAILURE_FINGERPRINT } from './chunk-load-constants';
import {
  isChunkLoadError,
  isChunkLoadErrorMessage,
} from './is-chunk-load-error';

const exceptionMessages = (event: ErrorEvent): string[] => {
  const messages: string[] = [];
  if (event.message) {
    messages.push(event.message);
  }
  for (const exception of event.exception?.values ?? []) {
    if (exception.value) {
      messages.push(exception.value);
    }
  }
  return messages;
};

/**
 * Forces every chunk-fetch failure onto one Sentry issue. Default grouping
 * includes the full message, so each deploy hash (`page-CbPiInod.js`) becomes
 * its own issue.
 */
export const applyChunkLoadFingerprint = (
  event: ErrorEvent,
  originalException: unknown
): ErrorEvent => {
  const matchesException = isChunkLoadError(originalException);
  const matchesEvent = exceptionMessages(event).some((message) =>
    isChunkLoadErrorMessage(message)
  );

  if (matchesException || matchesEvent) {
    event.fingerprint = [...DYNAMIC_IMPORT_FETCH_FAILURE_FINGERPRINT];
  }

  return event;
};
